var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1690725675251,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8801,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.106122 476.995918h-203.755102c-43.885714 0-79.412245-35.526531-79.412244-79.412245v-203.755102C114.938776 150.465306 150.465306 114.938776 194.35102 114.938776h203.755102c43.885714 0 79.412245 35.526531 79.412245 79.412244v203.755102c-0.522449 43.363265-36.04898 78.889796-79.412245 78.889796zM398.106122 909.061224h-203.755102c-43.885714 0-79.412245-35.526531-79.412244-79.412244v-203.755102c0-43.885714 35.526531-79.412245 79.412244-79.412245h203.755102c43.885714 0 79.412245 35.526531 79.412245 79.412245v203.755102c-0.522449 43.885714-36.04898 79.412245-79.412245 79.412244zM829.64898 909.061224h-203.755102c-43.885714 0-79.412245-35.526531-79.412245-79.412244v-203.755102c0-43.885714 35.526531-79.412245 79.412245-79.412245h203.755102c43.885714 0 79.412245 35.526531 79.412244 79.412245v203.755102c0 43.885714-35.526531 79.412245-79.412244 79.412244z",
    fill: "#11b4da",
    "p-id": 8802,
    "data-spm-anchor-id": "a313x.7781069.0.i6",
    className: "selected"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M727.771429 476.995918c-99.787755 0-181.289796-81.502041-181.289796-181.289796S627.983673 114.938776 727.771429 114.938776 909.061224 196.440816 909.061224 296.228571s-81.502041 180.767347-181.289795 180.767347z",
    fill: "#F2CB51",
    "p-id": 8803
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.6e2814f815ee1138867b1479894e4203.svg";
export { ForwardRef as ReactComponent };